import axios from 'axios'

const token = `${process.env.GF_CONSUMER_KEY}:${process.env.GF_CONSUMER_SECRET}`
const encodedToken = Buffer.from(token).toString('base64')
const headers = { Authorization: `Basic ${encodedToken}` }

const axiosInstance = axios.create({
  baseURL: process.env.ADMIN_BASE_URL,
  headers
})

export { axiosInstance }
